import type { ReactNode } from "react"
import type { LucideIcon } from "lucide-react"

interface SettingsSectionProps {
  title: string
  icon: LucideIcon
  children: ReactNode
}

export function SettingsSection({ title, icon: Icon, children }: SettingsSectionProps) {
  return (
    <div className="flex flex-col gap-4 bg-slate-100 p-6 rounded-xl border border-slate-200 shadow-sm">
      <h3 className="text-xl font-bold text-slate-900 flex items-center gap-3">
        <Icon className="w-6 h-6 text-indigo-600" />
        {title}
      </h3>
      <div className="flex flex-col gap-4 pt-2">{children}</div>
    </div>
  )
}
